var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3H3C2.17157 3 1.5 3.67157 1.5 4.5V7.5H7.5H9H22.5V4.5C22.5 3.67157 21.8284 3 21 3ZM7.5 9H1.5V19.5C1.5 20.3284 2.17157 21 3 21H7.5V9ZM9 21V9H22.5V19.5C22.5 20.3284 21.8284 21 21 21H9ZM9 22.5H7.5H3C1.34315 22.5 0 21.1569 0 19.5V9V7.5V4.5C0 2.84315 1.34315 1.5 3 1.5H21C22.6569 1.5 24 2.84315 24 4.5V7.5V9V19.5C24 21.1569 22.6569 22.5 21 22.5H9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout);
export default __webpack_public_path__ + "static/media/layout.a6a395146bbe5d1dbcf465dd66b34627.svg";
export { ForwardRef as ReactComponent };